import {
  getCurrentWeekOfYear,
  getPreviousWeekOfYear
} from "features/parents/pages/weekly-reports/utils/time";

import { linkToChild } from "../../links";

export function linkToWeeklyReportsRoute(childId = ":userId") {
  return `${linkToChild(childId)}/report`;
}

export function linkToWeeklyReportsPage(userId: string) {
  return linkToWeeklyReportsRoute(userId);
}

export function linkToWeeklyReportsPageWithWeekOfYear({
  userId,
  date: { week, year }
}: {
  userId: string;
  date: { week: number; year: number };
}) {
  const link = linkToWeeklyReportsRoute(userId);
  return `${link}?week=${week}&year=${year}`;
}

export function linkToWeeklyReportsForPreviousWeek(userId: string) {
  const date = getPreviousWeekOfYear();
  return linkToWeeklyReportsPageWithWeekOfYear({ userId, date });
}

export function linkToWeeklyReportsForCurrentWeek(userId: string) {
  const date = getCurrentWeekOfYear();
  return linkToWeeklyReportsPageWithWeekOfYear({ userId, date });
}
